const dbName = "PortraitBuilder";
const storeName = "state";
const version = 8;
const request = indexedDB.open(dbName, version);

request.onupgradeneeded = function (event) {
  const db = event.target.result;

  if (!db.objectStoreNames.contains(storeName)) {
    const objectStore = db.createObjectStore(storeName, {
      keyPath: "userId",
    });

    objectStore.createIndex("notifications", "notifications", {
      unique: false,
    });
    objectStore.createIndex("additionalProducts", "additionalProducts", {
      unique: false,
    });
    objectStore.createIndex("currentVariant", "currentVariant", {
      unique: false,
    });
    objectStore.createIndex("quantity", "quantity", { unique: false });
    objectStore.createIndex("downloadedImages", "downloadedImages", {
      unique: false,
    });
    objectStore.createIndex("customBackgroundImage", "customBackgroundImage", {
      unique: false,
    });
    objectStore.createIndex("step", "step", { unique: false });
    objectStore.createIndex("continueShopping", "continueShopping", {
      unique: false,
    });
    objectStore.createIndex("isSubmited", "isSubmited", { unique: false });
    objectStore.createIndex("modalCount", "modalCount", { unique: false });
    objectStore.createIndex("heavenlyImage", "heavenlyImage", {
      unique: false,
    });
    objectStore.createIndex("clothingImage", "clothingImage", {
      unique: false,
    });
    objectStore.createIndex("date", "date", { unique: false });
    objectStore.createIndex("purchaseId", "purchaseId", { unique: false });
  }
};

request.onsuccess = function (event) {
  const db = event.target.result;
};

request.onerror = function (event) {
  console.error("Error opening IndexedDB:", event.target.error);
};

function saveUserData(
  userId,
  notifications = [],
  additionalProducts = [],
  currentVariant = {},
  quantity = 0,
  downloadedImages = [],
  customBackgroundImage = [],
  step = 1,
  continueShopping = "false",
  isSubmited = "false",
  heavenlyImage = [],
  clothingImage = [],
  date = "",
  purchaseId = "",
) {
  const request = indexedDB.open(dbName, version);

  request.onsuccess = function (event) {
    const db = event.target.result;

    const transaction = db.transaction([storeName], "readwrite");
    const objectStore = transaction.objectStore(storeName);

    const userData = {
      userId: userId,
      notifications: JSON.stringify(notifications),
      additionalProducts: JSON.stringify(additionalProducts),
      currentVariant: JSON.stringify(currentVariant),
      quantity,
      downloadedImages: JSON.stringify(downloadedImages),
      customBackgroundImage,
      step,
      continueShopping,
      isSubmited,
      heavenlyImage,
      clothingImage,
      date,
      purchaseId,
    };

    const addRequest = objectStore.put(userData);

    addRequest.onsuccess = function () {};

    addRequest.onerror = function (event) {
      console.error("Error saving user data:", event.target.error);
    };
  };

  request.onerror = function (event) {
    console.error("Error opening database:", event.target.error);
  };
}

async function fetchUserData(userId) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName, version);

    request.onsuccess = function (event) {
      const db = event.target.result;

      const transaction = db.transaction([storeName], "readonly");
      const objectStore = transaction.objectStore(storeName);

      // Get the data by userId
      const getRequest = objectStore.get(userId);

      getRequest.onsuccess = function (event) {
        const userData = event.target.result;
        // Resolve the promise with the fetched data
        if (userData) {
          resolve(userData);
        } else {
          console.log("No data found for this user");
          resolve(null); // Resolve with null if no data is found
        }
      };

      getRequest.onerror = function (event) {
        console.error("Error fetching user data:", event.target.error);
        reject(event.target.error); // Reject the promise in case of an error
      };
    };

    request.onerror = function (event) {
      console.error("Error opening database:", event.target.error);
      reject(event.target.error); // Reject the promise if the database can't be opened
    };
  });
}

async function getUserData(userId) {
  try {
    const data = await fetchUserData(userId);
    if (!data) {
      return {
        notifications: [],
        additionalProducts: [],
        currentVariant: null,
        downloadedImages: [],
        isSubmited: "false",
        step: 1,
        continueShopping: "false",
        purchaseId: "",
      };
    }

    data.notifications = safeParse(data.notifications, []);
    data.additionalProducts = safeParse(data.additionalProducts, []);
    data.currentVariant = safeParse(data.currentVariant, null);
    data.downloadedImages = safeParse(data.downloadedImages, []);

    return data;
  } catch (error) {
    console.error("Error during data fetching:", error);
    return {
      notifications: [],
      additionalProducts: [],
      currentVariant: null,
      downloadedImages: [],
      isSubmited: "false",
      step: 1,
      continueShopping: "false",
      purchaseId: "",
    };
  }
}

function safeParse(value, fallback) {
  try {
    if (!value) return fallback;
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

window.getUserData = getUserData;
window.saveUserData = saveUserData;
window.fetchUserData = fetchUserData;

const setupProceedOrderFlow = async () => {
  // Chech if it is first load
  const modalCount = sessionStorage.getItem("pb-modal-count") || 0;
  sessionStorage.setItem("pb-modal-count", +modalCount + 1);

  const storeName = "state";
  const BUTTON_LABEL = "Proceed your Order";

  const data = await getUserData(storeName);
  if (!data) return;

  const { date, currentVariant } = data;
  const handle = currentVariant?.handle;

  if (!handle || !date) return;

  const savedTime = new Date(date).getTime();
  const currentTime = Date.now();

  // 48 hours = 48 * 60 * 60 * 1000 ms
  const hours48 = 48 * 60 * 60 * 1000;

  if (currentTime - savedTime > hours48) {
    saveUserData(storeName, [], [], {}, 0, [], [], "false", "");
    return;
  }

  const selectors = [
    ".site-nav .custom-order-btn",
    ".edit_banner .edit_banner_left-button",
  ];

  const proceedBtns = document.querySelectorAll(selectors.join(", "));
  if (!proceedBtns || proceedBtns?.length < 1) return;

  const buildUrl = (handle) => {
    const baseUrl = `/products/${handle}`;
    const url = new URL(baseUrl, window.location.origin);
    url.searchParams.set("proceed", "true");
    return url?.toString();
  };

  const onProceedBtnClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const url = buildUrl(handle);
    window.location.assign(url);
  };

  const onProceedBtnKeydown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      e.stopPropagation();
      const url = buildUrl(handle);
      window.location.assign(url);
    }
  };

  proceedBtns.forEach((btn) => {
    btn.innerText = BUTTON_LABEL;
    btn.addEventListener("click", onProceedBtnClick);
    btn.addEventListener("keydow", onProceedBtnKeydown);
  });
};

setupProceedOrderFlow();
